interface TooltipLinesProps {
  lines: Array<string | undefined>
}

function TooltipLines({ lines }: TooltipLinesProps) {
  return (
    <>
      {lines.map((line) =>
        line === undefined ? null : <div key={line}>{line}</div>
      )}
    </>
  )
}

export default TooltipLines
